// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2f4WH","title":"Images45_title__c2CzV","images":"Images45_images__ZmXTx"};